









































































































	import Vue from 'vue';
	import Component from 'vue-class-component';
	import ArticleTemplate from '@/components/maternite/template/ArticleTemplate.vue';
	import { JsonObj } from 'vue-meta/types/vue-meta';

	const Props = Vue.extend({
		props: {
			//id Article
			id: {
				type: String,
				default: ''
			},
			moisSel: {
				type: String,
				default: '1'
			},
			dpg: {
				type: String,
				default: ''
			}
		},
		methods: {
			isLinkedArticle: function() {
				// Recuperation de l'article au format JSON
				var article = this.$t('components.maternite.articles.listearticles.article'+this.id) as unknown as JsonObj;
				// Test s'il contient des linked articles
				if (article.linkArticle) {
					return true;
				}
				return false;
			},
			// Méthode permettant de récupérer l'ensemble des articles du mois sans l'article sélectionné
			autresArticlesDisponibles: function() {
				// Récupère l'ensemble des articles du même type du mois sélectionné
				var typeArticle =  this.$t('components.maternite.articles.listearticles.article'+this.id+'.type');
				let articlesMois = this.$t('components.maternite.'+typeArticle+'.articles.mois'+ this.moisSel) as unknown as Number[];
				// Clone de la liste des article
				let resultat = new Array<Number>(articlesMois.length);
				resultat= articlesMois.slice();
				// Suppression de l'id de l'article s'il est dans la liste
				if (resultat.indexOf(+this.id) != -1) {
					resultat.splice(resultat.indexOf(+this.id),1);
				}
				return resultat;
			}
		}
	});

	@Component({
		components: {
			ArticleTemplate
        }
	})
	export default class AffichageArticle extends Props {

	}
